<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12" vs-md="12" vs-sm="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Admin Accounts
          <vs-button
            class="ml-auto"
            type="filled"
            icon="add_circle"
            size="small"
            @click="addAdmin=true"
          >Add New Admin</vs-button>
        </h3>
        <p class="card-subtitle">List of allAdmins accounts with various operations.</p>
        <div class="table-responsive">
        
        <table class="table" scope="col">
          <tr>
            <th scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">Accounts Name</th>
            <th scope="col">Email Id</th>
            <th scope="col">Phone No.</th>
            <th scope="col">Country</th>
            <th scope="col">Verified</th>
            <th scope="col">Actions</th>
          </tr>
          <tr v-for="(item, index) in allAdmins" :key="item._id">
            <td scope="col">{{ index + 1 }}</td>
            <td scope="col">
               <vs-avatar v-if="item.image == '' || item.image == null" size="50px" :src="require('@/assets/images/users/3.png')" />
              <vs-avatar v-else :src="baseUrl+item.image" size="50px" />
            </td>
            <td scope="col">{{ item.name }}</td>
            <td scope="col">{{ item.email }}</td>
            <td scope="col">{{ item.phone }}</td>
            <td scope="col">{{ item.country }}</td>
            <td scope="col">
              <vs-chip class="statusChip" v-if="item.isEmailVerified" color="success">Verified</vs-chip>
              <vs-chip class="statusChip" v-else color="danger">Not Verified</vs-chip>
            </td>
            <td scope="col">
              <span v-if="item._id != currentUser._id">
                <vs-icon
                  style="cursor:pointer;"
                  icon="delete"
                  v-on:click.native="activateDeletePopup(item)"
                ></vs-icon>
              </span>
            </td>
          </tr>
        </table>
        </div>
        <!-- Code -->
        <vs-popup class="holamundo" title="Add New Admin" :active.sync="addAdmin">
          <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        
          <vs-row>
            <form @submit.prevent="btnAddAdmin">
          <vs-col >
              <vs-input required label="Name" v-model="admin.name" />
            </vs-col>
            <vs-col >
              <vs-input required type="number" label="Phone" v-model="admin.phone" />
            </vs-col>
            <vs-col >
              <vs-input required label="Country" v-model="admin.country" />
            </vs-col>
            <vs-col >
              <vs-input required label="Email" v-model="admin.email" />
            </vs-col>
            <vs-col >
              <vs-input required type="password" label="Password" v-model="admin.password" />
            </vs-col>
            <vs-col>
             <uploader
                label="Profile Image (Try to use square image Please Don't Upload Video)"
                v-model="admin.image"
                :file="admin.image"
              />
            </vs-col>
            <vs-col >
              <vs-button button="submit">Add New Admin</vs-button>
            </vs-col>
            </form>
          </vs-row>
      </vs-card>
    </vs-col>
  </vs-row>
        </vs-popup>
      </vs-card>
    </vs-col>
    
    <vs-popup
      class="holamundo"
      small
      style="z-index:21111;"
      title="OTP?"
      :active.sync="otpPopup"
    >
      <p>Enter OTP you recieved at {{admin.email}}.</p>
      
      <vs-col >
        <vs-input required label="" v-model="otp" />
      </vs-col>
      <div>
        <vs-button @click="verifyOtp">Submit</vs-button>
        <vs-button
          color="grey"
          style="margin-left: 15px;z-index:21111;"
          @click="otpPopup = false"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      small
      title="Delete?"
      :active.sync="deletePopup"
    >
      <p>Are you sure you want to Delete {{selectedAdmin? selectedAdmin.name : ""}}?</p>
      <div>
        <vs-button @click="deleteAdmin">Delete</vs-button>
        <vs-button
          color="grey"
          style="margin-left: 15px;"
          @click="deletePopup = false"
          >Cancel</vs-button
        >
      </div>
    </vs-popup>
  </vs-row>
</template>

<style>
.table td{
  vertical-align: middle;
}
</style>

<script>
import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
export default {
  name: "Admin-Users",
  data: () => ({
    admin: {},
    allAdmins: [],
    addAdmin: false,
    otpPopup: false,
    otp: "",
    selectedEmail:"",
    selectedAdmin: {},
    deletePopup: false,
    currentUser: {},
    baseUrl: API.API_BASE.substring(0, API.API_BASE.lastIndexOf("/")) + "/",
  }),
  components: {
    uploader
  },
  methods: {
    fetchAllAccounts() {
      this.$vs.loading();
      api
        .get(API.ALL_USERS, {})
        .then((r) => {
          this.allAdmins = r.data.data.filter(
            (user) => user.roleType === "ADMIN"
          );
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            color: "danger",
            position: "top-right",
          });
        });
    },
    activateDeletePopup(item) {
      this.selectedAdmin = item;
      this.deletePopup = true;
    },
    deleteAdmin() {
      api
        .delete(API.DELETE_USER + "/" + this.selectedAdmin._id)
        .then((r) => {
          if (r.status !== 200) {
            this.$vs.notify({
              title: "Delete user failed",
              text: "Admin couldn't be deleted",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.fetchAllAccounts();
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            color: "danger",
            position: "top-right",
          });
        });
      this.deletePopup = false;
    },
    btnAddAdmin() {
      api
        .post(API.ADD_ADMIN, this.admin)
        .then((r) => {
          if (r.data.status === 200) {
            this.selectedEmail = this.admin.email;
            this.sendOtp();
          } else {
            this.$vs.notify({
              title: "Account Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            color: "danger",
            position: "top-right",
          });
        });
    },
    sendOtp() {
      api
        .post(API.SEND_OTP, {
          email: this.admin.email,
        })
        .then((r) => {
          if (r.status !== 200) {
            this.$vs.notify({
              title: "OTP failed",
              text: "Please try again later",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Success",
              text: "OTP Send Successfully to " + this.admin.email,
              color: "success",
              position: "top-right",
            });
            this.otpPopup = true;
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            color: "danger",
            position: "top-right",
          });
        });
    },
    verifyOtp() {
      api
        .post(API.VERIFY_EMAIL, {
          email: this.admin.email,
          otp: this.otp,
        })
        .then((r) => {
          if (r.status !== 200) {
            this.$vs.notify({
              title: "OTP Verification failed",
              text: "Please try again",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Success",
              text: "Admin added successfully " + this.admin.email,
              color: "success",
              position: "top-right",
            });
            this.admin = {};
            this.otpPopup = false;
            this.addAdmin = false;
          this.fetchAllAccounts();
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: err.response.data.message,
            color: "danger",
            position: "top-right",
          });
        });
    },
  },
  created() {
    this.fetchAllAccounts();
    this.currentUser = JSON.parse(localStorage.user);
  },
  watch: {
    addAdmin(value) {
      if(!value){
        this.admin = {}
      }
    },
  },
};
</script>
